import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/hotelChainDictionaryInfo', request)
}

export {get}
